import React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableLogs } from "./components/LogsTable/TableLogs";

type Props = {};

export const Logs = (prop: Props) => {
	return (
		<>
			<HelmetDexteel title="MES and System Logs" />
			<TableLogs />
		</>
	);
};
